import { portalPaths } from '@provision/portal-routes';
import { NavigationDataItem } from 'src/components/Navbar/use-navigation-items';
import { UserGroupRules } from 'src/graphql';

export const REPORTS_NAVIGATION: NavigationDataItem[] = [
  {
    id: 'subscriptions',
    title: 'Subscriptions',
    iconData: { name: 'receipt', library: 'lucide' },
    path: portalPaths.settings.stripeReport(),
    allowedRules: [UserGroupRules.Reports],
    isMultitenancyAllowed: false,
    isMobileSupported: false,
  },
];
